export default () => {
  const messageListeners = [];

  return {
    createMiddleware() {
      return () => next => action => {
        const actionType = action.type;

        next(action);

        if (actionType === 'messageEvents/onMessage') {
          const { type: messageType } = action.payload;
          if (messageType) {
            messageListeners
              .filter(({ type }) => type === messageType)
              .forEach(({ fn }) => fn(action.payload));
          }
        }
      };
    },

    onModel(model, store) {
      const { messageListeners: listener, name } = model;
      if (listener) {
        const modelDispatcher = store.dispatch[name];
        Object.entries(listener).forEach(([type, value]) =>
          messageListeners.push({ type, fn: value.bind(modelDispatcher) }),
        );
      }
    },
  };
};
